import React, { useState, useContext, useEffect, useRef } from "react";
// import AuthHelperMethods from "./AuthHelperMethods";
import { MyContext, ListContext } from "./MyContext";
//import { saveAs } from "file-saver";
import COLORS from "./styleConstants";
import { dateTimeISOtoStringMed } from "./momentUtils";
import { Trash, ArrowDown } from "./icons";
const APIURL = import.meta.env.VITE_DATA_API;

//import APIURL from "./Constants2";
import Auth from "./Auth";
//const APIURL = process.env.REACT_APP_APIURL;
//const APIURL = process.env.NODE_ENV == "development" ? "http://localhost:3001/" : process.env.REACT_APP_APIURL;

export const FileUpload = () => {
  const MOBILE_HEADER_BREAKPOINT = 640;
  const { listState, dispatch2 } = useContext(ListContext);
  const { mystate, dispatch } = useContext(MyContext);

  const [image, setImage] = useState({});
  const [fileList, setFileList] = useState([]);
  const [currentLink, setCurrentLink] = useState();
  const [currentFileName, setCurrentFileName] = useState();

  const [lastUpload, setLastUpload] = useState();
  const [name, setName] = useState("");
  const [selectedFile, setSelectedFile] = useState({});
  const [currentDownload, selectCurrentDownload] = useState();
  const [isSmallMobile, setIsSmallMobile] = useState(
    typeof window !== "undefined" &&
      window.innerWidth <= MOBILE_HEADER_BREAKPOINT,
  );
  const minSize = 0;
  const maxSize = 10737418240;
  const fileUpload = useRef(null);

  console.log("FileUpload4");

  useEffect(() => {
    const fetchData = async () => {
      if (!listState.currentHorse.id) return;
      try {
        let params = { horse_id: listState.currentHorse.id };
        const result = await Auth.api("file_storages/list", "get", params);
        setFileList(result.data.horsefiles);
      } catch (error) {
        console.log("error");
      }
    };
    fetchData();
  }, [lastUpload, listState.currentHorse.id]);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallMobile(window.innerWidth <= MOBILE_HEADER_BREAKPOINT);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const FileList = () => {
    const deleteFile = async (fileh) => {
      const shouldDelete = window.confirm(
        `Delete ${fileh.file_name}? This cannot be undone.`,
      );
      if (!shouldDelete) return;

      dispatch({ type: "FETCH_INIT" });

      try {
        const result = await Auth.api("file_storages/delete", "post", {
          id: fileh.id,
        });

        if (result) {
          setFileList((prevList) =>
            prevList.filter((fileItem) => fileItem.id !== fileh.id),
          );
          setLastUpload(Date.now());
        }

        dispatch({ type: "FETCH_SUCCESS" });
      } catch (error) {
        dispatch({ type: "FETCH_ERROR" });
        alert(
          error && error.message
            ? error.message
            : "Unable to delete the file right now.",
        );
      }
    };

    const getUrl = async (fileh) => {
      // setCurrentLink();
      setCurrentFileName(fileh.file_name);
      dispatch({
        type: "FETCH_INIT",
      });
      let filename = `${fileh.file_code}`;

      try {
        const response = await fetch(
          `${APIURL}file_storages/getUrl?q=${filename}`,
          {
            method: "GET",
            headers: { Authorization: `Bearer  ${Auth.getToken()}` },
          },
        );
        const data = await response.json();
        if (data.url) {
          // Fetch the file as a blob
          const fileResponse = await fetch(data.url);
          const blob = await fileResponse.blob();

          // Create a temporary anchor to trigger download
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileh.file_name;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        dispatch({ type: "FETCH_SUCCESS" });
      } catch (e) {
        dispatch({ type: "FETCH_ERROR" });
      }
    };

    if (fileList.length == 0)
      return <div>{"There are no documents on record for this horse"}</div>;

    return (
      <>
        {!isSmallMobile && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              color: COLORS.textgrey,
              marginTop: 20,
              marginBottom: 8,
              fontWeight: "bold",
              fontSize: 20,
            }}
          >
            <div style={{ width: "350px", flex: "1 1 auto" }}>File name</div>
            <div style={{ flex: "0 0 auto", width: 200 }}>Date uploaded</div>
            <div style={{ width: 100, textAlign: "center" }}>Action</div>
          </div>
        )}
        <div style={{ marginTop: 0 }}>
          {fileList.map((fileh) => (
            <>
              <div
                className="rowDiv"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flexStart",
                  fontSize: 14,
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    color: COLORS.textgrey,
                    flex: "1 1 auto",
                    width: "350px",
                    flexWrap: "wrap",
                    fontSize: 14,
                  }}
                >
                  {`${fileh.file_name}`}
                </div>
                {!isSmallMobile && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      fontSize: 14,
                      color: COLORS.textgrey,
                      width: 200,
                    }}
                  >
                    {dateTimeISOtoStringMed(fileh.created_at)}
                  </div>
                )}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: 100,
                    gap: 20,
                  }}
                >
                  <div
                    style={{ cursor: "pointer", display: "flex" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      getUrl(fileh);
                    }}
                    title="Download file"
                  >
                    <ArrowDown color={COLORS.blue} />
                  </div>
                  <div
                    style={{ cursor: "pointer", display: "flex" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      deleteFile(fileh);
                    }}
                    title="Delete file"
                  >
                    <Trash fontSize={16} />
                  </div>
                </div>
              </div>
            </>
          ))}
        </div>
      </>
    );
  };

  // Upload file immediately after selection
  const uploadFile = (file) => {
    if (!file) return;
    if (file.size > maxSize) {
      alert("File is too large - must be under 5MB");
      return;
    }
    dispatch({
      type: "FETCH_INIT",
    });
    setSelectedFile(file);
    setName(file.name);
    const formData = new FormData();
    formData.append("name", file.name);
    formData.append("file", file);
    formData.append("horse_id", listState.currentHorse.id);
    let x = file.name.split(".").pop();
    formData.append("extension", x);
    fetch(`${APIURL}file_storages/upload`, {
      method: "POST",
      body: formData,
      headers: { Authorization: `Bearer  ${Auth.getToken()}` },
    })
      .then(async (response) => {
        if (!response.ok) {
          let errorMsg = `Upload failed: ${response.status} ${response.statusText}`;
          try {
            const errData = await response.json();
            if (errData && errData.error) errorMsg += ` - ${errData.error}`;
          } catch {}
          throw new Error(errorMsg);
        }
        return response.json();
      })
      .then((data) => {
        setLastUpload(data.id);
        setName("");
        setSelectedFile();
        dispatch({ type: "FETCH_SUCCESS" }); // Stop spinner on success
      })
      .catch((err) => {
        // Handles both HTTP and network errors
        dispatch({ type: "FETCH_ERROR" });
        alert(
          err && err.message
            ? err.message
            : "A network error occurred during upload.",
        );
      });
  };

  const FileUploader = () => {
    const fileInput = useRef(null);

    const handleFileInput = (e) => {
      const file = e.target.files[0];
      if (file) {
        uploadFile(file);
      }
    };

    return (
      <div className="file-uploader" style={{ marginBottom: 20 }}>
        <input
          type="file"
          onChange={handleFileInput}
          ref={fileInput}
          style={{ display: "none" }}
        />
        <button
          type="button"
          onClick={(e) => fileInput.current && fileInput.current.click(e)}
          className="btn btn-primary"
        >
          {"Browse Files To Upload"}
        </button>
        <div>Maximum upload size is 10MB</div>
      </div>
    );
  };

  // onSuccess no longer needed, logic moved to uploadFile

  if (!listState.currentHorse.id) return null;

  return (
    <div
      className="form"
      style={{ display: "flex", flex: "1 1 100%", flexDirection: "column" }}
    >
      <FileUploader />
      <FileList />
    </div>
  );
};
